import Line from "../../../../../src/entities/Line/Line";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { Coord } from "../../../../../src/types/Interface";


export default class LineManager {
  private cCoord: Coord;
  lines = [
    new Line({ color: 0x21D4FE, isEqualSymbol: true }),
    new Line({ color: 0x21D4FE, isEqualSymbol: true }),
    new Line(),

    new Line({ color: 0xb06efe, isEqualSymbol: true }),
    new Line({ color: 0xb06efe, isEqualSymbol: true }),
    new Line()
  ]
  constructor(cCoord: Coord) {
    this.cCoord = cCoord;
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.clearAll())
  }
  clearAll = () => this.lines.forEach(l =>{
    l.setVisibleOfEqualSymbol(false);
     l.clear()
  });
  draw(points: Coord[], chordsPoints: Coord[][]) {
    const chordA = chordsPoints[0];
    const chordB = chordsPoints[1];

    this.lines[0].draw(chordA[0], chordA[1]);
    this.lines[1].draw(chordA[1], chordA[2]);
    this.lines[2].draw(this.cCoord, points[0]);

    this.lines[3].draw(chordB[0], chordB[1]);
    this.lines[4].draw(chordB[1], chordB[2]);
    this.lines[5].draw(this.cCoord, points[1]);
  }
}